import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/SessionExpiredPopup.css";
import { useLogout } from "services/LogoutProvider";

const SessionExpiredPopup: React.FC = () => {
  const { isSessionExpired, handleSessionExpiredConfirm } = useLogout();
  return (
    <Dialog
      open={isSessionExpired}
      onClose={handleSessionExpiredConfirm}
      PaperProps={{
        className: "session-expired-popup-container",
      }}
      BackdropProps={{
        className: "session-expired-popup-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="session-expired-popup-header">Session Expired</div>
        <div className="session-expired-popup-divider"></div>
        <div className="session-expired-popup-containt-container">
          <p>Your session has expired. Please log in again.</p>
        </div>
        <div
          className="session-expired-popup-button"
          onClick={handleSessionExpiredConfirm}
        >
          <div>Okay</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SessionExpiredPopup;
